import React, {useContext} from "react";
import {graphql, useStaticQuery} from "gatsby";
import MainMenu from "../Menu";
import {SettingsContext} from "../../context/SettingsContext";

const OnlyMenuButtonTopBar = (props) => {
    const {allStrapiEntities: entities} = useStaticQuery(staticQuery);
    const {settings} = useContext(SettingsContext)
    const {topbarSettings} = props;
    const Menu = props.menu || MainMenu;

    return (
        <>
            <div
                className={"only-menu-button"}
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    zIndex: 1,
                    paddingRight: '1rem',
                    color: topbarSettings?.foregroundColor || '#000',
                }}
            >
                <span
                    style={{
                        content: '',
                        width: '35px',
                        height: '35px',
                        background: topbarSettings?.backgroundColor || '#fffa',
                        position: 'absolute',
                        display: 'block',
                        left: '6px',
                        top: '6px',
                    }}
                ></span>
                <Menu {...props} settings={settings} entities={entities} />
            </div>
        </>
    )
}

export default OnlyMenuButtonTopBar;

const staticQuery = graphql`
    query {
        allStrapiEntities {
            nodes {
                identifier
                title
                locale
            }
        }
    }
`;
